import { Breadcrumbs } from 'components/breadcrumbs';
import MarketplaceFooter from 'components/footer-marketplace/MarketplaceFooter';
import Partners from 'pages/shop-home-page/partners';
import ShopNavBar from 'pages/shop-home-page/shop-nav-bar';
import { ReactElement, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { getMarketContent } from 'utils/marketContent';
import './index.scss';

export default function ContentPage(): ReactElement {
  const params = useParams();
  const market = getMarketContent();
  const data = market.contentPages;
  const [imgs, setImgs] = useState<string[]>([]);
  const [title, setTitle] = useState<string>('');
  const [breadcrumbText, setBreadcrumbText] = useState<string>('');
  const [breadcrumbBGImage, setBreadcrumbBGImage] = useState<string>('');
  const [iframeOnly, setIframeOnly] = useState<boolean>(false);
  const [iframeOnlyHTML, setIframeOnlyHTML] = useState<string>('');
  const [htmlContent, setHTMLContent] = useState<string>('');
  const [vimeo, setVimeo] = useState({
    accountId: '',
    videoId: '',
  });
  const [callToAction, setCallToAction] = useState({
    label: '',
    labelClass: '',
    labelLink: '',
  });

  useEffect(() => {
    if (market && params.contentURL) {
      for (let i = 0; i < data.length; i++) {
        const obj = data[i];
        if (obj.contentURL === params.contentURL) {
          setImgs(obj.imgs);
          setTitle(obj.title);
          setBreadcrumbText(obj.breadcrumbText);
          setBreadcrumbBGImage(obj.breadcrumbBGImage);
          setIframeOnly(obj.iframeOnly);
          setIframeOnlyHTML(obj.iframeOnlyHTML);
          setHTMLContent(obj.htmlContent);
          setVimeo(obj.vimeo);
          setCallToAction(obj.callToAction);
        } else {
          // TODO: fwd to homepage without breaking routes above
          // window.location.href = '/';
        }
      }
    }
  }, [data, market, params.contentURL]);
  return (
    <>
      <ShopNavBar />
      {iframeOnly === true ? (
        <>{parse(iframeOnlyHTML)}</>
      ) : (
        <>
          {breadcrumbText && (
            <Breadcrumbs label={breadcrumbText} bg={breadcrumbBGImage} />
          )}
          <section id={params.contentURL} className="content-page">
            <div className="container px-4 py-8 md:px-0">
              <div className="grid">
                <div className="col-12 md:col-8 md:col-offset-2">
                  {title && <h1 className="text-center">{title}</h1>}
                  {imgs.length > 0 && (
                    <>
                      {imgs.map(value => (
                        <img
                          key={value}
                          className="block w-full my-8"
                          src={value}
                          alt=""
                        />
                      ))}
                    </>
                  )}
                  <div>{parse(htmlContent)}</div>
                  {callToAction?.labelLink && (
                    <Link
                      to={callToAction?.labelLink}
                      className={callToAction?.labelClass}
                    >
                      {callToAction?.label}
                    </Link>
                  )}
                  {vimeo?.accountId && (
                    <div className="video-wrap mt-5">
                      <div className="inner-video-wrap">
                        <ReactPlayerLoader
                          accountId={vimeo?.accountId}
                          videoId={vimeo?.videoId}
                          options={{ controls: false }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      <Partners />
      <MarketplaceFooter />
    </>
  );
}
